module.exports = __webpack_public_path__ + "img/내밑에서일할생각없냐.c12730c7.png";